// Multi-language labels
export const LABELS = {
  en: {
    step1Title: "Select Pickup Area",
    kantoRegion: "Kanto Area",
    kansaiRegion: "Kansai Area",
    otherRegion: "Other Areas",
    step2Title: "Select Service Type",
    step3Title: "Order Details",
    step4Title: "Select Vehicle",
    step5Title: "Confirm Order",
    transfer: "Transfer",
    transferDesc: "One-way pickup/drop-off",
    charter: "Charter",
    charterDesc: "Hourly rental service",
    next: "Next",
    back: "Back",
    submit: "Submit Order",
    departureDate: "Departure Date",
    departureTime: "Departure Time",
    pickupLocation: "Pickup Location (Detail)",
    destination: "Destination (Detail)",
    flightNumber: "Flight/Ship Number",
    passengerCount: "Passengers",
    luggageCount: "Luggage",
    charterHours: "Charter Duration (hours)",
    destinationArea: "Destination Area",
    childSeats: "Child Seats",
    childSeatNote: "First seat free, ¥2,000 each after",
    extraServices: "Extra Services",
    customerCode: "Group Code",
    customerName: "Customer Name",
    phone: "Phone",
    totalPrice: "Total Price",
    priceBreakdown: "Price Breakdown",
    basePrice: "Base Price",
    overtimePrice: "Overtime Fee",
    nightSurcharge: "Night Surcharge",
    childSeatPrice: "Child Seat Fee",
    extraServicePrice: "Extra Services",
    returnTimePrice: "Return Time Fee",
    pendingConfirmation: "Pending Confirmation",
    pendingConfirmationNote: "Orders within 48 hours require admin confirmation",
    orderSuccess: "Order submitted successfully!",
    orderSuccessQuote: "Quote request submitted! Admin will contact you with pricing.",
    selectArea: "Please select an area",
    other: "Other",
    otherInput: "Enter location manually",
    hours: "hours",
    optional: "Optional",
    required: "Required",
    selectTerminal: "Select Terminal",
    terminalOrHotel: "Terminal / Hotel",
    endLocation: "End Location",
    endInTokyo: "Return to Tokyo",
    endNotInTokyo: "Not return to Tokyo",
    endInKanazawa: "Return to Kanazawa",
    endNotInKanazawa: "Not return to Kanazawa",
    endLocationOther: "Other (Enter location)",
    selectEndLocation: "Select end location",
    pickupExtraTime: "Pickup extra time",
    endExtraTime: "End location extra time",
    requiresQuote: "Requires Quote",
    requiresQuoteNote: "Admin will provide a quote for this order",
    confirmWithTony: "Please confirm price with admin Tony",
    quoteMode: "Quote Mode",
    quoteModeNote: "Please enter pickup and end addresses. Admin will provide pricing.",
    locationPlaceholder: "Hotel name and address...",
  },
  ja: {
    step1Title: "乗車エリアを選択",
    kantoRegion: "関東エリア",
    kansaiRegion: "関西エリア",
    otherRegion: "その他エリア",
    step2Title: "サービスタイプを選択",
    step3Title: "予約詳細",
    step4Title: "車両を選択",
    step5Title: "予約確認",
    transfer: "送迎",
    transferDesc: "片道送迎サービス",
    charter: "貸切",
    charterDesc: "時間制チャーター",
    next: "次へ",
    back: "戻る",
    submit: "予約を確定",
    departureDate: "出発日",
    departureTime: "出発時間",
    pickupLocation: "乗車場所（詳細）",
    destination: "目的地（詳細）",
    flightNumber: "フライト/船名",
    passengerCount: "乗客人数",
    luggageCount: "荷物数",
    charterHours: "貸切時間（時間）",
    destinationArea: "目的地エリア",
    childSeats: "チャイルドシート",
    childSeatNote: "1台目無料、2台目以降¥2,000",
    extraServices: "追加サービス",
    customerCode: "団体名",
    customerName: "顧客名",
    phone: "電話番号",
    totalPrice: "合計金額",
    priceBreakdown: "料金内訳",
    basePrice: "基本料金",
    overtimePrice: "超過料金",
    nightSurcharge: "深夜早朝料金",
    childSeatPrice: "チャイルドシート料金",
    extraServicePrice: "追加サービス料金",
    returnTimePrice: "返程時間料金",
    pendingConfirmation: "確認中",
    pendingConfirmationNote: "48時間以内のご予約は管理者の確認が必要です",
    orderSuccess: "ご予約が完了しました！",
    orderSuccessQuote: "お見積り依頼を送信しました！管理者から価格をお知らせします。",
    selectArea: "エリアを選択してください",
    other: "その他",
    otherInput: "手動で入力",
    hours: "時間",
    optional: "任意",
    required: "必須",
    selectTerminal: "ターミナルを選択",
    terminalOrHotel: "ターミナル / ホテル",
    endLocation: "終了地点",
    endInTokyo: "東京に戻る",
    endNotInTokyo: "東京に戻らない",
    endInKanazawa: "金沢に戻る",
    endNotInKanazawa: "金沢に戻らない",
    endLocationOther: "その他（住所入力）",
    selectEndLocation: "終了地点を選択",
    pickupExtraTime: "出発地追加時間",
    endExtraTime: "終了地追加時間",
    requiresQuote: "お見積り必要",
    requiresQuoteNote: "管理者がお見積りをご提供します",
    confirmWithTony: "管理者Tonyに料金をご確認ください",
    quoteMode: "お見積りモード",
    quoteModeNote: "出発地と終了地の住所をご入力ください。管理者が料金をご提供します。",
    locationPlaceholder: "ホテル名と住所を入力してください",
  },
  zh: {
    step1Title: "选择上车地区",
    kantoRegion: "关东地区",
    kansaiRegion: "关西地区",
    otherRegion: "其他地区",
    step2Title: "选择服务类型",
    step3Title: "订单详情",
    step4Title: "选择车型",
    step5Title: "确认订单",
    transfer: "单程接送",
    transferDesc: "单程接送服务",
    charter: "包车",
    charterDesc: "按时计费包车服务",
    next: "下一步",
    back: "返回",
    submit: "提交订单",
    departureDate: "出发日期",
    departureTime: "出发时间",
    pickupLocation: "上车地点（详细地址）",
    destination: "目的地（详细地址）",
    flightNumber: "航班号/船名",
    passengerCount: "乘客人数",
    luggageCount: "行李数量",
    charterHours: "包车时长（小时）",
    destinationArea: "目的地区域",
    childSeats: "儿童座椅",
    childSeatNote: "第1个免费，之后每个¥2,000",
    extraServices: "额外服务",
    customerCode: "团体名",
    customerName: "客户名称",
    phone: "联系电话",
    totalPrice: "总价",
    priceBreakdown: "价格明细",
    basePrice: "基础价格",
    overtimePrice: "超时费用",
    nightSurcharge: "夜间附加费",
    childSeatPrice: "儿童座椅费",
    extraServicePrice: "额外服务费",
    returnTimePrice: "返程时间费",
    pendingConfirmation: "确认中",
    pendingConfirmationNote: "48小时内的订单需要管理员确认",
    orderSuccess: "订单提交成功！",
    orderSuccessQuote: "报价请求已提交！管理员将与您联系确认价格。",
    selectArea: "请选择地区",
    other: "其他",
    otherInput: "手动输入地址",
    hours: "小时",
    optional: "可选",
    required: "必填",
    selectTerminal: "选择航站楼",
    terminalOrHotel: "航站楼 / 酒店",
    endLocation: "结束地点",
    endInTokyo: "返回东京",
    endNotInTokyo: "不返回东京",
    endInKanazawa: "返回金泽",
    endNotInKanazawa: "不返回金泽",
    endLocationOther: "其他（输入地址）",
    selectEndLocation: "选择结束地点",
    pickupExtraTime: "出发地加算时间",
    endExtraTime: "结束地加算时间",
    requiresQuote: "需要报价",
    requiresQuoteNote: "管理员将提供报价",
    confirmWithTony: "请与管理员Tony确认价格",
    quoteMode: "报价模式",
    quoteModeNote: "请输入出发和结束地址，管理员将提供价格。",
    locationPlaceholder: "请输入酒店名称和地址",
  },
  es: {
    step1Title: "Seleccionar zona de recogida",
    kantoRegion: "Región de Kanto",
    kansaiRegion: "Región de Kansai",
    otherRegion: "Otras regiones",
    step2Title: "Seleccionar tipo de servicio",
    step3Title: "Detalles de la reserva",
    step4Title: "Seleccionar vehículo",
    step5Title: "Confirmar reserva",
    transfer: "Traslado",
    transferDesc: "Servicio de recogida y destino de ida",
    charter: "Chárter",
    charterDesc: "Servicio privado por horas",
    next: "Siguiente",
    back: "Volver",
    submit: "Confirmar reserva",
    departureDate: "Fecha de salida",
    departureTime: "Hora de salida",
    pickupLocation: "Lugar de recogida (detalle)",
    destination: "Destino (detalle)",
    flightNumber: "Número de vuelo/barco",
    passengerCount: "Pasajeros",
    luggageCount: "Equipaje",
    charterHours: "Duración del chárter (horas)",
    destinationArea: "Zona de destino",
    childSeats: "Sillas infantiles",
    childSeatNote: "La primera es gratuita; ¥2,000 por cada adicional",
    extraServices: "Servicios adicionales",
    customerCode: "Código de grupo",
    customerName: "Nombre del cliente",
    phone: "Teléfono",
    totalPrice: "Precio total",
    priceBreakdown: "Desglose del precio",
    basePrice: "Precio base",
    overtimePrice: "Cargo por tiempo extra",
    nightSurcharge: "Recargo nocturno",
    childSeatPrice: "Cargo por silla infantil",
    extraServicePrice: "Servicios adicionales",
    returnTimePrice: "Cargo por tiempo de regreso",
    pendingConfirmation: "Pendiente de confirmación",
    pendingConfirmationNote: "Las reservas dentro de las próximas 48 horas requieren confirmación del administrador",
    orderSuccess: "¡Reserva enviada correctamente!",
    orderSuccessQuote: "¡Solicitud de presupuesto enviada! El administrador se pondrá en contacto para confirmar el precio.",
    selectArea: "Seleccione una zona",
    other: "Otro",
    otherInput: "Introducir ubicación manualmente",
    hours: "horas",
    optional: "Opcional",
    required: "Obligatorio",
    selectTerminal: "Seleccionar terminal",
    terminalOrHotel: "Terminal / Hotel",
    endLocation: "Lugar de finalización",
    endInTokyo: "Regreso a Tokio",
    endNotInTokyo: "Sin regreso a Tokio",
    endInKanazawa: "Regreso a Kanazawa",
    endNotInKanazawa: "Sin regreso a Kanazawa",
    endLocationOther: "Otro (introducir ubicación)",
    selectEndLocation: "Seleccionar lugar de finalización",
    pickupExtraTime: "Tiempo adicional de recogida",
    endExtraTime: "Tiempo adicional del lugar final",
    requiresQuote: "Requiere presupuesto",
    requiresQuoteNote: "El administrador proporcionará un presupuesto para esta reserva",
    confirmWithTony: "Confirme el precio con el administrador Tony",
    quoteMode: "Modo presupuesto",
    quoteModeNote: "Introduzca las direcciones de recogida y destino. El administrador proporcionará el precio.",
    locationPlaceholder: "Nombre y dirección del hotel...",
  },
};

export const AREA_NAMES_ES = {
  "haneda airport": "Aeropuerto de Haneda",
  haneda_airport: "Aeropuerto de Haneda",
  narita_airport: "Aeropuerto de Narita",
  kansai_airport: "Aeropuerto de Kansai (KIX)",
  itami_airport: "Aeropuerto de Itami (ITM)",
  tokyo: "Tokio",
  yokohama_port: "Puerto de Yokohama",
  kamakura: "Kamakura",
  chiba: "Chiba",
  hakone: "Hakone",
  mt_fuji: "Monte Fuji",
  nikko: "Nikko",
  kawagoe: "Kawagoe",
  shizuoka: "Shizuoka",
  mishima: "Mishima",
  odawara: "Odawara",
  karuizawa: "Karuizawa",
  "Disney_land/Sea": "Disneyland / DisneySea",
  kanazawa: "Kanazawa",
  nagoya: "Nagoya",
  Takayama_Shirakawako: "Takayama / Shirakawa-go",
  okinawa: "Okinawa",
  osaka: "Osaka",
  kyoto: "Kioto",
  nara: "Nara",
  kobe: "Kobe",
  other: "Otro",
};

export const getLocalizedAreaName = (area, language = "en") => {
  if (!area) return "";
  const code = typeof area === "string" ? area : area.code;
  if (language === "es") {
    return area.name_es || AREA_NAMES_ES[code] || area.name_en || code;
  }
  return area[`name_${language}`] || area.name_en || area.name_ja || area.name_zh || code;
};

// Extra services configuration
export const EXTRA_SERVICES_CONFIG = [
  { id: "infant_seat", price: 2000, name_en: "Infant Seat (¥2,000 each, including the first)", name_ja: "ベビーシート（1台目から1台¥2,000）", name_zh: "婴儿座椅（首个起每个¥2,000）", name_es: "Silla para bebé (¥2,000 cada una, desde la primera)" },
  { id: "airport_sign", price: 2000, name_en: "Airport Welcome Sign", name_ja: "空港お迎えボード", name_zh: "机场举牌", name_es: "Cartel de bienvenida en el aeropuerto" },
  { id: "tokyo_station_sign", price: 3500, name_en: "Shinkansen departure / arrival platform assistance", name_ja: "新幹線ホームのご案内", name_zh: "新干线送站/接站 站台引导", name_es: "Asistencia en el andén de Shinkansen para salida / llegada" },
  { id: "odawara_station_sign", price: 2500, name_en: "Odawara Station Sign", name_ja: "小田原駅お迎えボード", name_zh: "小田原车站举牌", name_es: "Cartel de bienvenida en la estación de Odawara" },
  { id: "hotel_sign", price: 0, name_en: "Hotel Welcome Sign", name_ja: "ホテルお迎えボード", name_zh: "酒店举牌", name_es: "Cartel de bienvenida en el hotel" },
  { id: "shinkansen_ticket", price: 3000, name_en: "Shinkansen Ticket Pickup", name_ja: "新幹線チケット受取", name_zh: "取新干线票", name_es: "Recogida de billetes de Shinkansen" },
  { id: "hiace_14_seat_upgrade", price: 10000, vehicleTypes: ["hiace"], name_en: "14-seat Hiace Upgrade", name_ja: "14座ハイエースアップグレード", name_zh: "升级到14座海狮", name_es: "Mejora a Hiace de 14 plazas" },
  { id: "fuji_5th_station", price: 10000, name_en: "Mt. Fuji 5th Station fuel surcharge", name_ja: "富士山五合目ガソリンチャージ", name_zh: "富士山五合目燃油附加费", name_es: "Recargo de combustible para la 5.ª estación del monte Fuji" },
  { id: "other", price: 0, name_en: "Other Service", name_ja: "その他サービス", name_zh: "其他服务", name_es: "Otro servicio" },
];

// Vehicle types - base list, will be filtered based on selected region
export const ALL_VEHICLE_TYPES = [
  { id: "alphard", name_en: "Alphard", name_ja: "アルファード", name_zh: "阿尔法", icon: "🚐" },
  { id: "hiace", name_en: "Hiace", name_ja: "ハイエース", name_zh: "海狮", icon: "🚌" },
  { id: "premium_hiace", name_en: "Premium Hiace", name_ja: "プレミアムハイエース", name_zh: "豪华海狮", icon: "🚎" },
];

// For backwards compatibility
export const VEHICLE_TYPES = ALL_VEHICLE_TYPES;

// Airport terminal options
export const AIRPORT_TERMINALS = {
  narita_airport: [
    { id: "T1", name_en: "Terminal 1", name_ja: "第1ターミナル", name_zh: "T1航站楼", name_es: "Terminal 1" },
    { id: "T2", name_en: "Terminal 2", name_ja: "第2ターミナル", name_zh: "T2航站楼", name_es: "Terminal 2" },
    { id: "T3", name_en: "Terminal 3", name_ja: "第3ターミナル", name_zh: "T3航站楼", name_es: "Terminal 3" },
    { id: "hotel", name_en: "Hotel (specify below)", name_ja: "ホテル（下記に記入）", name_zh: "酒店（请在下方填写）", name_es: "Hotel (especifique abajo)" },
  ],
  haneda_airport: [
    { id: "T1", name_en: "Terminal 1 (Domestic)", name_ja: "第1ターミナル（国内線）", name_zh: "T1航站楼（国内）", name_es: "Terminal 1 (nacional)" },
    { id: "T2", name_en: "Terminal 2 (Domestic)", name_ja: "第2ターミナル（国内線）", name_zh: "T2航站楼（国内）", name_es: "Terminal 2 (nacional)" },
    { id: "T3", name_en: "Terminal 3 (International)", name_ja: "第3ターミナル（国際線）", name_zh: "T3航站楼（国际）", name_es: "Terminal 3 (internacional)" },
    { id: "hotel", name_en: "Hotel (specify below)", name_ja: "ホテル（下記に記入）", name_zh: "酒店（请在下方填写）", name_es: "Hotel (especifique abajo)" },
  ],
};

// Kanazawa destination areas - now fetched dynamically from endLocationOptions
// This constant is kept for backwards compatibility fallback only
export const KANAZAWA_DESTINATION_AREAS_FALLBACK = [
  { code: "kanazawa", name_en: "Kanazawa City", name_ja: "金沢市内", name_zh: "金泽市区", name_es: "Ciudad de Kanazawa" },
  { code: "Shiragawako", name_en: "Shirakawa-go", name_ja: "白川郷", name_zh: "白川乡", name_es: "Shirakawa-go" },
  { code: "other", name_en: "Other (Quote required)", name_ja: "その他（お見積り）", name_zh: "其他（需报价）", name_es: "Otro (requiere presupuesto)" },
];
